export const SEARCH_QUICK_TYPE_COMPANY: string = 'company';
export const SEARCH_QUICK_TYPE_PERSON: string = 'person';
export const SEARCH_QUICK_TYPE_DEAL: string = 'deal';
